import React from "react";
import { TimePicker } from "antd";
const format = "HH:mm";
const TimeArrival = ({
  index,
  timeArrival,
  changeTimeArrivalInput,

  setFieldValue,
}) => {
  return (
    <TimePicker
      className="form-control"
      style={{
        width: "98%",
        borderRadius: "4px",
      }}
      id={`flightLegs.onward[${index}]arrivalTime`}
      name={`flightLegs.onward[${index}]arrivalTime`}
      use24Hours
      value={timeArrival && timeArrival[index]?.time}
      onChange={(time, timeString) => {
        changeTimeArrivalInput(time, timeString, index);
        setFieldValue(`flightLegs.onward[${index}]arrivalTime`, timeString);
      }}
      required
      format={format}
    />
  );
};

export default TimeArrival;
